import React, { useState } from 'react';
import './GenAIHomeFooter.css';
import { JJ_IM_Logo } from "../../assets";
import AuthoringDisclaimer from '../Authoring/AuthoringDisclaimer';
const GenAIHomeFooter = (props) => {
  const [showDisclaimerPopup, setShowDisclaimerPopup] = useState(false);
  const handleDisclaimerClose = async () => {
    setShowDisclaimerPopup(false);
  }
  return (
    <div className="footerbar-container">
      <div className="footerbar-spacer">
        <div className="footerbar-inner">
          <div className="footerbar-left">
            {/* Brand placeholder - replace with logo or markup as needed */}
            {/* <div className="footerbar-brand" aria-hidden="true" /> */}
            <img src={JJ_IM_Logo} alt="Loading Data" className="footerbar-brand" />
          </div>
          {
            props.isShowAIOverview && (<div className="genAIRecommended-content-footer-content">
              <p>iMedical Search GenAI Answers can make mistakes please verify critical information.<br /> You are reminded that no personal information or GxP data should be uploaded onto this platform, and you are required to comply with the. <a className="authoring-model-body-content-link" onClick={() => { setShowDisclaimerPopup(true) }}>GenAI Adherence Policy</a></p>
            </div>)
          }          <div className="footerbar-rights">All Rights Reserved</div>
        </div>
      </div>
      {showDisclaimerPopup && <AuthoringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={handleDisclaimerClose} />}
    </div>
  );
};

export default GenAIHomeFooter;
